/**
 * Bootstrap de sessão executado antes do React montar.
 *
 * Substitui a lógica do middleware esquilo `RedirectAppContent.php:157-165`
 * que capturava `?token=` do redirect do trex e salvava em cookie.
 *
 * Agora roda no próprio coruja:
 *   1. Lê `?token=` da URL (vem do redirect do trex)
 *   2. Persiste em localStorage via token-storage
 *   3. Remove o param da URL para não aparecer no histórico
 *
 * Tem que rodar **antes** de qualquer `ReactDOM.render` para que
 * o handshake encontre o token logo no primeiro request.
 *
 * @module core/session/bootstrap
 */
import { setToken } from './token-storage';

export function bootstrapTokenFromUrl() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const tokenFromUrl = params.get('token');
  if (!tokenFromUrl) return;

  setToken(tokenFromUrl);

  params.delete('token');
  const newSearch = params.toString();
  const newUrl =
    window.location.pathname +
    (newSearch ? `?${newSearch}` : '') +
    window.location.hash;
  window.history.replaceState({}, '', newUrl);
}
